
import React from 'react';

interface ImageCollageProps {
  imageUrls: string[];
  title: string;
}

const ImageCollage: React.FC<ImageCollageProps> = ({ imageUrls, title }) => {
  const renderCollage = () => {
    if (imageUrls.length === 4) {
      return (
        <div className="absolute inset-0 grid grid-cols-2 grid-rows-2 gap-1">
          {imageUrls.map((url, index) => (
            <div key={index} className="relative">
              <img src={url} alt={`${title} collage image ${index + 1}`} className="w-full h-full object-cover" />
              <div className="absolute inset-0 bg-gradient-to-t from-black/70 to-transparent"></div>
            </div>
          ))}
        </div>
      );
    }

    if (imageUrls.length === 3) {
      return (
        <div className="absolute inset-0 grid grid-cols-2 grid-rows-2 gap-1">
          <div className="col-span-2 row-span-1 relative">
            <img src={imageUrls[0]} alt={`${title} collage image 1`} className="w-full h-full object-cover" />
            <div className="absolute inset-0 bg-gradient-to-t from-black/70 to-transparent"></div>
          </div>
          <div className="col-span-1 row-span-1 relative">
            <img src={imageUrls[1]} alt={`${title} collage image 2`} className="w-full h-full object-cover" />
            <div className="absolute inset-0 bg-gradient-to-t from-black/70 to-transparent"></div>
          </div>
          <div className="col-span-1 row-span-1 relative">
            <img src={imageUrls[2]} alt={`${title} collage image 3`} className="w-full h-full object-cover" />
            <div className="absolute inset-0 bg-gradient-to-t from-black/70 to-transparent"></div>
          </div>
        </div>
      );
    }

    return (
      <div className="relative w-full h-full">
        <img src={imageUrls[0]} alt={title} className="absolute inset-0 w-full h-full object-cover" />
        <div className="absolute inset-0 bg-gradient-to-t from-black/70 to-transparent"></div>
      </div>
    );
  };

  return renderCollage();
};

export default ImageCollage;
